import { DollarSign } from 'styled-icons/fa-solid/DollarSign';
import { PoundSign } from 'styled-icons/fa-solid/PoundSign';
import { EuroSymbol } from 'styled-icons/material/EuroSymbol';

export const mapCurrencyIcon = {
  EUR: EuroSymbol,
  GBP: PoundSign,
  USD: DollarSign
};
